<script setup>
  import { useState } from 'nuxt/app'
  import { ref } from 'vue'
  import { useMainStore } from '../stores/main-store'

  const mainStore = useMainStore()
  const countries = useState('countries')
  const languages = useState('languages')
  const currencies = useState('currencies')

  const { setLocale } = useI18n()
  const showGlobalSettingDialog = ref(false)
  const activeTab = ref(0)

  // unused
  const detectedCountryState = useState('detectedCountry')
  const detectedCountryCookie = useCookie('detectedCountry')
  const countryZoneSelected = ref('')
  const countryZoneCitySelected = ref('')

  const countrySelectedState = useState('countrySelected')
  const countrySelectedCookie = useCookie('countrySelected')
  const countrySelected = ref('')
  const langSelected = ref('')
  const currencySelected = ref('')

  const saveSettings = () => {
    if (
      String(countrySelected.value).toLowerCase() !== countrySelectedState.value
    ) {
      const countrySelectedFormated = String(
        countrySelected.value
      ).toLowerCase()
      countrySelectedState.value = countrySelectedFormated
      countrySelectedCookie.value = countrySelectedFormated
      setLocale(countrySelectedFormated)
      window.location.href = `/${countrySelectedFormated}`
    }

    mainStore.setCurrencySelected(currencySelected.value)
    showGlobalSettingDialog.value = false
  }

  const tabs = [
    { name: 'País', icon: 'mdi-map-marker' },
    { name: 'Idioma', icon: 'mdi-translate' },
    { name: 'Moneda', icon: 'mdi-currency-usd' },
  ]

  const showDialog = () => {
    showGlobalSettingDialog.value = true
    countrySelected.value = String(countrySelectedState.value).toUpperCase()
    langSelected.value = mainStore.langSelected
    currencySelected.value = sessionStorage.getItem('currencySelected')
  }

  defineExpose({
    showDialog,
  })
</script>

<template>
  <Dialog
    v-model:visible="showGlobalSettingDialog"
    :modal="true"
    :draggable="false"
    dismissableMask
    class="md:min-w-[450px]"
    header="Configuración Global"
  >
    <div>
      <!-- Tabs -->
      <div class="border-b border-gray-200">
        <nav class="flex space-x-8" aria-label="Settings">
          <button
            v-for="(tab, index) in tabs"
            :key="index"
            @click="activeTab = index"
            size="large"
            :class="[
              activeTab === index
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
              'group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm',
            ]"
          >
            <i :class="tab.icon" class="mr-2 mdi"></i>
            {{ tab.name }}
          </button>
        </nav>
      </div>

      <div class="mt-4">
        <div v-show="activeTab === 0" class="space-y-4">
          <div
            v-for="country in countries"
            :key="country.code"
            class="p-4 border rounded-lg cursor-pointer"
            :class="{ 'border-primary-500': countrySelected === country.code }"
            @click="countrySelected = country.code"
          >
            <div class="flex items-center space-x-3">
              <img
                :src="country.icon_url"
                :alt="country.name"
                class="w-8 h-8"
              />
              <span class="font-medium">{{ country.name }}</span>
            </div>

            <!--            <div v-if="countrySelected === country.code" class="mt-4 space-y-4">
              &lt;!&ndash; Zones &ndash;&gt;
              <div>
                <label class="block text-sm font-medium text-gray-700">Zona</label>
                <select
                  v-model="countryZoneSelected"
                  class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 rounded-md"
                >
                  <option value="">Todas las zonas</option>
                  <option v-for="zone in country.zones" :key="zone.id" :value="zone.id">
                    {{ zone.name }}
                  </option>
                </select>
              </div>

              &lt;!&ndash; Cities &ndash;&gt;
              <div v-if="countryZoneSelected">
                <label class="block text-sm font-medium text-gray-700">Ciudad</label>
                <select
                  v-model="countryZoneCitySelected"
                  class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 rounded-md"
                >
                  <option value="">Todas las ciudades</option>
                  <option
                    v-for="city in country.zones.find(z => z.id === countryZoneSelected)?.cities"
                    :key="city.id"
                    :value="city.id"
                  >
                    {{ city.name }}
                  </option>
                </select>
              </div>
            </div>-->
          </div>
        </div>

        <!-- Language Panel -->
        <div v-show="activeTab === 1" class="space-y-4">
          <div
            v-for="language in languages"
            :key="language.slug"
            class="p-4 border rounded-lg cursor-pointer"
            :class="{ 'border-primary-500': langSelected === language.slug }"
            @click="langSelected = language.slug"
          >
            <div class="flex items-center space-x-3">
              <Avatar
                :image="`/images/flags/${language.slug}.svg`"
                :alt="language.name"
                class="w-8 h-8"
              />
              <span class="font-medium">{{ language.name }}</span>
            </div>
          </div>
        </div>

        <!-- Currency Panel -->
        <div v-show="activeTab === 2" class="space-y-4">
          <div
            v-for="currency in currencies"
            :key="currency.code"
            class="p-4 border rounded-lg cursor-pointer"
            :class="{
              'border-primary-500': currencySelected === currency.code,
            }"
            @click="currencySelected = currency.code"
          >
            <div class="flex items-center justify-between">
              <div class="flex items-center space-x-3">
                <Avatar
                  :image="`/images/currencies/${currency.code}.png`"
                  :alt="currency.name"
                  class="w-8 h-8"
                />
                <span class="font-medium">{{ currency.name }}</span>
              </div>
              <span class="text-gray-500">{{ currency.code }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-6 flex justify-end space-x-3">
        <Button
          label="Cancelar"
          class="p-button-text"
          @click="showGlobalSettingDialog = false"
        />
        <Button label="Guardar" @click="saveSettings" />
      </div>
    </div>
  </Dialog>
</template>
